<div class="usage">
  <div class="top">
    <tile
      class="thumbnail"
      [metadata]="districtAndSchoolsUsage?.district"
      [level]="'usage'"
      *ngIf="districtAndSchoolsUsage"
      [role]="role"
    ></tile>

    <div class="school-table">
      <tile-title
        [title]="'School Average Monthly Usage'"
        [definition]="schoolUsageDef"
        [level]="'usage'"
        class="tile-title-block"
      ></tile-title>
      <school-usage-table
        [schools]="districtAndSchoolsUsage?.schools"
        *ngIf="districtAndSchoolsUsage"
      ></school-usage-table>
    </div>
  </div>
  <div class="bottom">
    <h4
      class="user-logins-title"
      [tooltip]="titleTooltip"
      [placement]="'right'"
    >
      Schoolzilla Views in Most Recent 4 Months
    </h4>
    <ng-template #titleTooltip>
      <title-tooltip
        [definition]="userLoginsDef"
        [title]="'Schoolzilla Views'"
        [hidePrefix]="true"
      ></title-tooltip>
    </ng-template>
    <user-logins-table
      [userLogins]="userLogins"
      *ngIf="userLogins"
    ></user-logins-table>
  </div>
</div>
